// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"2f84f1c5","295":"1f609570","312":"25d9eb3e","392":"579d5aac","817":"2028f1e0","828":"7016959e","955":"c2ccfc9e"}[chunkId] + ".chunk.css";
};